const LEAVE_TYPE_LABELS = {
  ANNUAL: "إجازة اعتيادية",
  SICK: "إجازة مرضية",
  CASUAL: "إجازة عارضة",
  UNPAID: "إجازة على الحساب الخاص",
  COMPENSATORY: "إجازة تعويضية",
  SPECIAL: "إجازة ممنوحة",
};

const HALF_DAY_PERIOD_LABELS = {
  FIRST_HALF: "أول الشيفت",
  SECOND_HALF: "آخر الشيفت",
};

export function listPunchLeaves(leaves) {
  return Array.isArray(leaves) ? leaves.filter(Boolean) : [];
}

export function formatLeaveCoverLabel(leave) {
  const type =
    LEAVE_TYPE_LABELS[leave?.leaveType] ||
    (leave?.leaveType ? String(leave.leaveType) : "إجازة");
  const half = HALF_DAY_PERIOD_LABELS[leave?.halfDayPeriod];
  return half ? `${type} · ${half}` : type;
}

export function formatPunchLeaveCoverText(leaves) {
  const list = listPunchLeaves(leaves);
  if (!list.length) return "";
  return list.map(formatLeaveCoverLabel).join("، ");
}
